"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS = exports.ADD_TO_POLICY_DIALOG_COLUMNS = void 0;
var ADD_TO_POLICY_DIALOG_COLUMNS;
(function (ADD_TO_POLICY_DIALOG_COLUMNS) {
    ADD_TO_POLICY_DIALOG_COLUMNS["name"] = "name";
    ADD_TO_POLICY_DIALOG_COLUMNS["description"] = "description";
})(ADD_TO_POLICY_DIALOG_COLUMNS = exports.ADD_TO_POLICY_DIALOG_COLUMNS || (exports.ADD_TO_POLICY_DIALOG_COLUMNS = {}));
var ADD_TO_POLICY_RESULT_DIALOG_COLUMNS;
(function (ADD_TO_POLICY_RESULT_DIALOG_COLUMNS) {
    ADD_TO_POLICY_RESULT_DIALOG_COLUMNS["instanceName"] = "instanceName";
    ADD_TO_POLICY_RESULT_DIALOG_COLUMNS["id"] = "id";
    ADD_TO_POLICY_RESULT_DIALOG_COLUMNS["policyName"] = "policyName";
    ADD_TO_POLICY_RESULT_DIALOG_COLUMNS["result"] = "result";
})(ADD_TO_POLICY_RESULT_DIALOG_COLUMNS = exports.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS || (exports.ADD_TO_POLICY_RESULT_DIALOG_COLUMNS = {}));
//# sourceMappingURL=constants.js.map